
export class Gender {
    public id: string;
    public genderName: string;
    public genderName_fr: string;
}
